module.exports = __webpack_public_path__ + "static/media/config-icon-white.4398bc97.svg";